import { Box, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const Description = ({ productDetail }) => {
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  return (
    <Box paddingY={5}>
      <Typography variant="body1">
        {productDetail?.description[currentLanguage]}
      </Typography>
    </Box>
  );
};

export default Description;
